export default "__VITE_ASSET__8BxQB4w$__"